import React, { useRef, useEffect } from 'react';
import * as S from './Styles';
import { useCarousel } from './BenefitCarouselHook';
export const BenefitCarousel = ({
  items,
  renderItem,
  cardClassName = '',
  showNavigation = true,
  onClickCallback,
  onSwipeCallback
}) => {
  const totalItems = items?.length;
  const cardRefs = useRef([]);
  const carousel = useCarousel(totalItems, onClickCallback, onSwipeCallback);
  useEffect(() => {
    cardRefs.current = cardRefs.current.slice(0, totalItems);
  }, [totalItems]);
  const handleCardClick = (index, e) => {
    if (carousel.dragDistance > 10) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (index !== carousel.currentIndex) {
      carousel.goToCard(index);
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    const item = items[index];
    if (item.onClickCallback && !e.defaultPrevented) {
      item.onClickCallback(index);
    }
  };
  if (totalItems === 0) return null;
  return /*#__PURE__*/React.createElement(S.Container, null, /*#__PURE__*/React.createElement(S.CardStackContainer, {
    onTouchStart: carousel.handleTouchStart,
    onTouchMove: carousel.handleTouchMove,
    onTouchEnd: carousel.handleTouchEnd,
    onKeyDown: carousel.handleKeyDown,
    tabIndex: 0
  }, items.map((item, index) => {
    const cardClass = carousel.getCardClass(index, cardClassName);
    const content = renderItem ? renderItem(item, index) : item.content;
    return /*#__PURE__*/React.createElement(S.CardWrapper, {
      key: item.id || index,
      ref: el => cardRefs.current[index] = el,
      className: cardClass,
      style: {
        zIndex: totalItems - index,
        height: index === carousel.currentIndex ? 'auto' : undefined
      },
      onClick: e => handleCardClick(index, e),
      tabIndex: index === carousel.currentIndex ? 0 : -1,
      "aria-hidden": index !== carousel.currentIndex
    }, content);
  })), showNavigation && totalItems > 1 && /*#__PURE__*/React.createElement(S.Navigation, {
    className: "carousel-navigation",
    "data-carousel-nav": true
  }, /*#__PURE__*/React.createElement(S.CounterText, {
    "aria-live": "polite"
  }, carousel.currentIndex + 1, " av ", totalItems)));
};
export default BenefitCarousel;
//# sourceMappingURL=BenefitCarousel.js.map